import { totalPosts, posts, getPosts } from '../apis';
import service from '../images/service.jpg'

let page = 1

tag posts-page
	prop limit = 5

	def mount
		getPosts({ limit })

	def onPage nextPage
		page = nextPage
		getPosts({ limit, skip: limit * (nextPage - 1)})

	<self.posts-page>
		<shape-header title="Posts" image=service>

		<pagination-tag.top total=totalPosts onPage=onPage currentPage=page limit=limit>

		<div.posts>
			for post, index in posts
				<post-tag data=post flipped=(index % 2 === 0)>

		<pagination-tag.bottom total=totalPosts onPage=onPage currentPage=page limit=limit>

		<footer-section>

css .posts-page
	min-height:100vh
	d:flex
	fld:column

	.shape-header
		h:300px

	.pagination-tag.top
		mt:3em
		mb:0

	.pagination-tag.bottom
		mt:0
		mb:2em

	.posts
		flg:1